import _ from 'lodash';
import defaultMeals from '../assets/doc/default-meals';
import * as fb from '../firebase';
import mealsService from './meals.service';
import workspaceService from './workspace.service';

export default {
  getRef(userIdId) {
    return fb.usersCollection.doc(userIdId);
  },

  async createAccount(userId, data) {
    await fb.usersCollection.doc(userId).set(data);
    if (data.workspaces && data.workspaces.length) {
      return this.createDefaultMeals(data.workspaces[0]);
    }
    return Promise.resolve();
  },

  async createDefaultMeals(workspaceRef) {
    const promises = [];
    defaultMeals.forEach((meal) => {
      mealsService.addMeal(meal, workspaceRef);
    });
    return Promise.all(promises);
  },

  async removeWorkspace(userId, workspaceId) {
    const userRef = this.getRef(userId);
    const user = await userRef.get();
    const userData = user.data();
    const currentWorkspaces = _.get(userData, 'workspaces', []);
    const workspacesToKeep = [];

    currentWorkspaces.forEach((workspace) => {
      if (workspace.id !== workspaceId) {
        // On le garde
        const workspaceRef = workspaceService.getRef(workspace.id);
        workspacesToKeep.push(workspaceRef);
      }
    });
    return userRef.update({ workspaces: workspacesToKeep });
  },

  /**
   * Modifie le mot de passe
   */
  updatePassword(oldPassword, newPassword) {
    const userEmail = _.get(fb.auth, 'currentUser.email', null);
    if (userEmail === null) {
      return Promise.reject(new Error('user email not found'));
    }
    // On vérifie l'ancien mot de passe et on modifie
    return new Promise((resolve, reject) => {
      fb.auth
        .signInWithEmailAndPassword(userEmail, oldPassword)
        .then(() => {
          fb.auth.currentUser
            .updatePassword(newPassword)
            .then(() => {
              resolve(true);
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
